import { TUserState } from '../../types/user';
import { createSlice } from '@reduxjs/toolkit';

const initialState: TUserState = {
  data: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const {
  reducer: userReducer,
  actions: { setUserData },
} = userSlice;
